import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingTop: theme.spacing(2),
        boxSizing: 'border-box',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
        flexShrink: 0,
    },
    headerTitle: {
        fontSize: '1.75rem',
        fontWeight: 700,
    },
}));
